// extracted by mini-css-extract-plugin
export default {"root":"IconLocation_root__ZDDw1"};